import React from "react";
import TabBar, { TabBarProps } from "../../../../shared/components/TabBar";
import { MaterialImport, MaterialOrder } from "../../../../data/entities";
import { ImportMaterialTab } from "../ImportMaterial";
// import EventLogMaterialOrderTab from "../EventLog";

interface MaterialOrderTabNavigationProps {
    materialOrderInfoTab: React.ReactNode;
    materialOrder: MaterialOrder;
    mergeMaterialOrder: Function;
    materialImports: MaterialImport[];
}

const MaterialOrderTabNavigation = ({
    materialOrderInfoTab,
    materialOrder,
    mergeMaterialOrder,
    materialImports,
}: MaterialOrderTabNavigationProps) => {
    const tabs: TabBarProps[] = [
        {
            label: "Thông tin",
            labelEN: "info",
            content: materialOrderInfoTab,
        },
        {
            label: "Nhập kho",
            labelEN: "Storage Import",
            content: (
                <ImportMaterialTab
                    materialOrder={materialOrder}
                    mergeMaterialOrder={mergeMaterialOrder}
                    materialImports={materialImports}
                />
            ),
        },
        // {
        //     label: "Sự kiện",
        //     labelEN: "event log",
        //     content: <EventLogMaterialOrderTab />,
        // }
    ];

    return <TabBar tabs={tabs} />;
};

export default MaterialOrderTabNavigation;
